/**
 * Remove HTML tags from string.
 */
var stripHtmlTags = function stripHtmlTags(str) {
  return str.replace(/<[^>]*>/g, '');
};

export default stripHtmlTags;